(ns ui.view.card.tasks.view
  (:require
   [ui.view.card.tasks.sub :as sub]
   [ui.view.card.tasks.event :as event]
   [ui.view.card.tasks.model :as model]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.entity-table :as entity-table]
   [ui.view.card.shared-components.entity-peek :as entity-peek]
   [ui.view.card.event :as common-event]
   [ui.view.card.sub :as common-sub]
   [common.localization :as loc]
   [re-frame.core :as rf]

     ;; TODO: remove this once we have a new entity editor  
   [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
   [frontend.view.modals.events :as modals]
   [ui.components.button.view :as button]
   [ui.view.card.shared-components.view :as card-shared]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]
   [ui.view.card.entity-list.view :as entity-list-view]))

(defn add-new-task-button
  [{:keys [entity-id preview-mode? primary-button? ctx]
    :as _props}]
  (let [component (if primary-button?
                    button/sm-primary-solid
                    button/sm-secondary-hollow)]
    [component
     {:disabled? preview-mode?
      :on-click (fn []
                  (modals/open-modal!
                   activity-entity-editor/modal-key
                   {:new-entity-type  :entity.type/task
                    :viewed-entity-id entity-id
                    :on-success-callback! (fn [_resp]
                                            (rf/dispatch-sync [::event/refetch-data ctx]))}))}
     [:i {:class "fal fa-plus"}]
     (loc/tr :create-task)]))

(defn empty-state-view
  [props]
  [:div
   {:class "flex flex-col items-center gap-4 py-5"}
   [:div
    {:class "relative"}
    [:i {:class "fal fa-tasks text-5xl font-thin"}]
    [:div
     {:class "absolute -bottom-1 -right-2 flex items-center justify-center bg-base-light rounded-full w-7 h-7"}
     [:i {:class "fal fa-plus text-2xl"}]]]
   [:p
    {:class "text-lg font-semibold"}
    (loc/tr :no-tasks-yet)]
   [:div
    {:class "flex justify-center"}
    [add-new-task-button
     (assoc props :primary-button? true)]]])

(defn delete-task-confirmation-modal
  [{:keys [ctx] :as _props}]
  (let [close #(rf/dispatch [::event/close-delete-confirmation-modal ctx])]
    [:dialog
     {:id (model/delete-task-confirmation-modal-id ctx)
      :class "border rounded p-0"}
     [:div
      {:class "relative p-3 flex flex-col gap-3 w-sm max-w-lg"}
      [:div
       {:class "absolute top-2 right-2"}
       [button/square-secondary-open
        {:on-click close}
        [:i {:class "fal fa-times"}]]]
      [:div
       {:class "flex justify-center mt-3"}
       [:i
        {:class "fal fa-exclamation-triangle text-2xl text-danger"}]]
      [:div
       [:h4
        {:class "text-center text-lg"}
        (loc/tr :delete-task?)]
       [:p
        {:class "text-center text-base-light-text text-sm"}
        (loc/tr :delete-task-confirmation-text)]]
      [:div
       {:class "flex justify-center gap-2"}
       [button/sm-secondary-hollow
        {:on-click close}
        (loc/tr :cancel)]
       [button/sm-danger-solid
        {:on-click #(rf/dispatch [::event/delete-task ctx])}
        (loc/tr :delete)]]]]))

(defn table-view
  [{:keys [card ctx] :as _props}]
  (let [table-data @(rf/subscribe [::sub/table-data ctx])
        columns (-> card :card/config :table-config :columns)
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])]
    [:div
     {:class "flex flex-col gap-5"}
     [entity-table/view
      {:columns columns
       :config (-> card :card/config :table)
       :data table-data
       :selected-row-id peek-entity-id
       :on-row-clicked (fn [{:keys [entity-id]}]
                         (rf/dispatch [::common-event/open-entity-peek-or-close-if-already-open ctx entity-id]))}]]))

(defn entity-peek-view
  [{:keys [card preview-mode? ctx] :as props}]
  (let [open? @(rf/subscribe [::common-sub/entity-peek-open? ctx])
        peek-entity-id @(rf/subscribe [::common-sub/entity-peek-entity-id ctx])
        entity-peek-config (-> card :card/config :entity-peek)
        entity-peek-data @(rf/subscribe [::common-sub/entity-peek-data ctx entity-peek-config])
        open-delete-confirmation #(rf/dispatch [::event/open-delete-confirmation-modal ctx peek-entity-id])]
    [entity-peek/view
     {:open? open?
      :data entity-peek-data
      :entity-type :entity.type/task
      :close (fn []
               (rf/dispatch [::common-event/close-entity-peek ctx]))
      :preview-mode? preview-mode?
      :edit (fn []
              (modals/open-modal!
               activity-entity-editor/modal-key
               {:entity-id peek-entity-id
                :on-success-callback! (fn []
                                        (rf/dispatch-sync [::event/refetch-data ctx]))
                :custom-delete-button
                [button/square-danger-hollow
                 {:class "h-10 w-10"
                  :tooltip (loc/tr :delete-task)
                  :on-click open-delete-confirmation}
                 [:i {:class "fal fa-trash-alt"}]]}))}]))

    ;; TODO
(defn component
  [{:keys [card ctx] :as props}]
  (let [title (:card/title card)
        tasks-count @(rf/subscribe [::sub/tasks-count ctx])
        tasks? (pos? tasks-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [card-container/view
     [:div
      {:class "flex"}
      [:div
       {:class "flex flex-col gap-2 grow"}
       [:div
        {:class "flex justify-between"}
        [card-title/view title]
        [:div
         {:class "flex items-center gap-2"}
         (when tasks?
           [add-new-task-button props])
         [card-shared/expand-card props]]]
       (cond
         loading?
         [entity-list-view/loading-skeleton]
         tasks? [table-view props]
         :else [empty-state-view props])]
      [entity-peek-view props]]]))

(defn full-screen-component
  [{:keys [ctx] :as props}]
  (let [tasks-count @(rf/subscribe [::sub/tasks-count ctx])
        tasks? (pos? tasks-count)
        loading? @(rf/subscribe [::common-sub/loading? ctx])]
    [full-screen-card/view
     (assoc props
            :header-right-actions
            [:div
             [add-new-task-button props]])

     (cond
       loading?
       [entity-list-view/loading-skeleton]

       tasks?
       [:div
        {:class "flex"}
        [:div
         {:class "grow"}
         [table-view props]]
        [entity-peek-view props]]

       :else
       [:div
        {:class "flex flex-col grow h-full justify-center items-center"}
        [empty-state-view props]])]))

(defn view
  [{:keys [full-screen?] :as props}]
  [:<>
   (if full-screen?
     [full-screen-component props]
     [component props])
   [delete-task-confirmation-modal props]])
